import React from 'react';
import classNameBind from 'classnames/bind';
import _isArray from 'lodash/isArray';
import { withTranslation } from '../Translator';
import Label from '../Label';
import styles from './AsControl.module.css';

const bindClasses = classNameBind.bind(styles);

export default () => (WrappedComponent) => {
  const AsControl = (props) => {
    const {
      id,
      label,
      required,
      error,
      info,
      touched,
      t,
      dataId,
      fullWidth,
      fullHeight,
    } = props;
    const hasError = _isArray(error) ? error.length > 0 : (error !== undefined && error !== '');
    const isInvalid = hasError && touched;

    return (
      <div
        className={bindClasses('wrapper', {
          invalid: isInvalid,
          'full-width': fullWidth,
          'full-height': fullHeight,
        })}
        data-ppuc-id={dataId}
      >
        {label && (
          <Label
            type="small"
            htmlFor={id}
            required={required}
            className={bindClasses('label')}
            dataId={`${dataId}.label`}
          >
            {label}
          </Label>
        )}
        <WrappedComponent {...props} dataId={undefined} />
        {(info && !isInvalid) && (
          <small
            className={bindClasses('message')}
            data-ppuc-id={`${dataId}.message`}
          >
            {info}
          </small>
        )}
        {isInvalid && (
          <small
            className={bindClasses('error-message')}
            data-ppuc-id={`${dataId}.errorMessage`}
          >
            {_isArray(error) ? t('AsControl.error-message.array') : error}
          </small>
        )}
      </div>
    );
  };

  AsControl.defaultProps = {
    required: false,
    id: null,
    dataId: 'Control',
    fullWidth: false,
  };

  return withTranslation('components')(AsControl);
};
